export enum StorageKeys {
	SESSION_KEY = 'SESSION-KEY',
}
